import { useMemo } from 'react';
import { getDisconnectedText } from './utils';
import { FaultTextPresenter } from './FaultTextPresenter';
import { ICycleItemCircleStateProps } from './types';
import { CycleCircleState } from './CycleCircleState';
import { ItemCircleState } from './ItemCircleState';
import { CycleControllerFaultedPresenter } from './CycleControllerFaultedPresenter';
import { useTranslation } from 'react-i18next';

export const CycleThermocoupleCircleState = (props: ICycleItemCircleStateProps) => {
  const { controllerDisconnected, controllerFaulted, itemNum, timestamp, state, controllerId } = props;
  const { t } = useTranslation();

  const disconnectedText = useMemo(() => {
    return getDisconnectedText(controllerDisconnected);
  }, [controllerDisconnected]);

  const isFaulted = useMemo(() => {
    return !!disconnectedText || !!controllerFaulted
  }, [disconnectedText, controllerFaulted]);

  if (!disconnectedText && !controllerFaulted) {
    return <ItemCircleState timestamp={timestamp} isFaulted={isFaulted} state={state} />;
  }

  return (
    <CycleCircleState circleProps={{ timestamp, isFaulted, state }} modalTitle={t('thermocouples.faultsModal.title', '', { tcNum: itemNum })} modalSize="minimized">
      {controllerFaulted ? (
        <CycleControllerFaultedPresenter
          controllerId={controllerId}
        />
      ) : (
        <FaultTextPresenter faultText={disconnectedText} />
      )}
    </CycleCircleState>
  );
};
